<template>
  <CollapsibleCard
    :value="true"
    :collapsibleIcon="icon"
    :collapsibleTitle="categoryName + ' info'"
    :padding="true"
  >
    <template v-slot>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="data.title"
          color="primary"
          :label="titleLabel"
          hide-details="auto"
          filled
          :rules="[(v) => !!v || 'Tittel må fylles ut!']"
        ></v-text-field>
        <v-textarea
          v-model="data.description"
          filled
          label="Beskrivelse"
          hide-details="auto"
          :rules="[(v) => !!v || 'Beskrivelse må fylles ut!']"
        ></v-textarea>
        <v-select
          v-model="data.aberrationTypeId"
          :items="typeSortet"
          hide-details="auto"
          filled
          label="Type"
          item-text="value"
          item-value="key"
          :rules="[(v) => !!v || 'Type må fylles ut!']"
          @change="changeAberrationType"
        ></v-select>

        <v-select
          v-model="data.aberrationCauseId"
          :items="aberrationCausesFilter"
          hide-details="auto"
          filled
          label="Årsak"
          item-text="name"
          item-value="id"
        ></v-select>
        <v-select
          v-model="data.severity"
          :items="aberrationSeverities"
          filled
          label="Alvorlighetsgrad"
          item-text="name"
          item-value="id"
          persistent-hint
        ></v-select>

        <DatePickerDialog
          v-model="data.registrated"
          label="Registrert"
          :max="moment().format()"
        />

        <v-autocomplete
          v-model="data.responsible"
          :items="users"
          color="primary"
          label="Ansvarlig"
          item-text="value"
          item-value="key"
          filled
          hide-details="auto"
          clearable
          :rules="[(v) => !!v || 'Ansvarlig må fylles ut!']"
        ></v-autocomplete>

        <DatePickerDialog
          v-model="data.timeLimit"
          label="Frist"
          :min="moment().format()"
        />
      </v-form>
    </template>
  </CollapsibleCard>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";
import { sortArrayObject } from "@/helpers/sort";

import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import DatePickerDialog from "@/components/shared/date/DatePickerDialog.vue";

export default Vue.extend({
  name: "AberrationInfoCard",
  props: {
    value: {},
    type: {
      type: Array,
    },
    status: {
      type: Array,
    },
    aberrationSeverities: {
      type: Array,
    },
    aberrationCauses: {
      type: Array,
    },
    users: {
      type: Array,
    },
    categoryName: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
    },
    titleLabel: {
      type: String,
      default: "Hva har skjedd",
    },
  },
  data() {
    return {
      valid: true,
      placeholders: ["Foo", "Bar", "Fizz", "Buzz"],
      moment,
    };
  },
  methods: {
    validate() {
      return (this as any).$refs.form.validate();
    },
    changeAberrationType() {
      delete (this as any).data.aberrationCauseId;
    },
  },
  computed: {
    data: {
      get(): any {
        return this.value;
      },
    },
    aberrationCausesFilter(): Array<any> {
      if ((this as any).data.aberrationTypeId) {
        var data = (this as any).aberrationCauses.filter((x) => {
          return x.aberrationTypeId === (this as any).data.aberrationTypeId;
        });
        return sortArrayObject(data, "name");
      }
      return [];
    },
    typeSortet(): Array<any> {
      return sortArrayObject(this.type, "value");
    },
  },
  components: {
    CollapsibleCard,
    DatePickerDialog,
  },
});
</script>
